// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { baseQueryWithAuth } from '../../common/baseQuery';

// initialize an empty api service that we'll inject endpoints into later as needed
export const userAddressApi = createApi({
  reducerPath: 'userAddressApi',
  baseQuery: baseQueryWithAuth,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  endpoints: () => ({})
});
